import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'

/**
 * Legacy URL. Reconciliation now starts from a bank account, so this route
 * only redirects. It sends the user to `/accounting/bank-accounts` directly,
 * not to `/accounting/reconciliation`, because that list route redirects to
 * the same place and the extra hop buys nothing.
 */
export const Route = createFileRoute('/_authenticated/accounting/reconcile/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_reconciliation.view')) {
      throw redirect({ to: '/accounting' })
    }

    throw redirect({ to: '/accounting/bank-accounts' })
  },
})
